import api from "plus/api";

export async function getAllUserOptions() {
  const response = await api.role.getAllUsers();
  if (response.data.data && response.data.data) {
    return response.data.data.map((item) => ({
      userName: item.realName,
      userId: item.userId,
      beisenUserId: item.beisenUserId,
      effective: item.effective,
    }));
  }
  // 当data不存在时返回空数组
  return [];
}